import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'informed'

import { ModalWrapper } from 'components/Modal'
import DateForm from './DateIntervalForm'
import Button from 'components/Button'
import Divider from 'components/Divider'

const DateIntervalFormModal = ({ onSubmit, children, ...rest }) => {
	const content = (
		<Form onSubmit={onSubmit} render={() => (
			<Fragment>
				<DateForm/>
				<Divider/>
				<Button type='submit' text='anwenden' status='primary' />
			</Fragment>
		)}/>
	)
	return (
		<ModalWrapper modal={{ ...rest, content }}>
			{openModal => children(openModal)}
		</ModalWrapper>
	)
}

DateIntervalFormModal.propTypes = {
	onSubmit: PropTypes.func.isRequired
}

DateIntervalFormModal.defaultProps = {
	width: 440,
	label: 'Wählen Sie ein Datum aus'
}

export default DateIntervalFormModal
